<template>
  <div class="table_wrap">
    <div class="c_table_wrap table_search_wrap">
      <div class="select_wrap mb11">
        <div class="filter-select-div el-div-long mb11">
          <span class="filter-select-span mr20">작성일</span>
          <span
            class="el-date-icon mr2"
            :class="checkFilterData() ? 'iconMove' : ''"
          >
          <span class="el-date-icon-img"></span>
          <el-date-picker
            v-model="filterDate"
            type="daterange"
            range-separator=""
            value-format="yyyy-MM-dd"
            start-placeholder="시작날짜"
            end-placeholder="끝 날짜"
            @change="setFilterFunc('cr', filterDate)"
            class="el-date-common"
            prefix-icon=" "
            clear-icon="el-icon-circle-close el-clear-icon"
          ></el-date-picker>
        </span>
        </div>
        <br />
        <div class="filter-select-div dp-block mr16">
          <span class="filter-select-span mr24">검색</span>
          <el-select v-model="searchInputOption" class="select mr5">
            <el-option :value="'su'" :label="'제목'"></el-option>
            <el-option :value="'mbni'" :label="'작성자'"></el-option>
          </el-select>
          <el-input
            class="table_s_input search-input mr7"
            v-model="searchInput"
            size=""
            placeholder="검색어를 입력해주세요."
            maxLength="30"
            @keyup.enter.native="setFilterFunc(searchInputOption, searchInput)"
          >
          </el-input>
          <el-button
            class="search-button"
            @click="setFilterFunc(searchInputOption, searchInput)"
          >
            검색
          </el-button>
          <div class="filter-show-count">
            <el-select v-model="size" @change="changePage('size', size)">
              <el-option
                v-for="sizeData in sizeList"
                :key="`size${sizeData}`"
                :value="sizeData"
                :label="`${sizeData}개씩 보기`"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import boardFilterUtil from "@/components/board/boardFilterUtil";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";

const { filterConfig } = boardFilterUtil;
export default {
  name: "BoardFilterSsamsContentLayout",
  mixins: [boardFilterUtil, boardTemplateUtil],
  components: {},
  provide() {
    return {};
  },
  inject: ["setPage", "setFilter"],
  props: {
    filterData: {
      default: () => {
        return {};
      },
    },
    paginationData: {
      default: () => {
        return { total: 0, page: 0, size: 0 };
      },
    },
  },
  data() {
    return {
      searchInput: "",
      searchInputOption: "su",
      filterDate: [],
      size: 10,
      sizeList: [10, 30, 50],
    };
  },
  created() {},
  mounted() {
    this.setterFilterDataInData();
  },
  beforeDestroy() {},
  destroyed() {},
  computed: {},
  methods: {
    setterFilterDataInData() {
      let classnames = Object.keys(this.filterData);
      classnames.forEach((classname) => {
        let obj = this.filterData[classname];
        let type = filterConfig[obj.key].type;
        if (this.hasOwnProperty(classname)) {
          if (type == "query") {
            this[classname] = obj.query;
            if (this.hasOwnProperty(classname + "Option")) {
              this[classname + "Option"] = obj.key;
            }
          } else if (type === "between") {
            this[classname] = [obj.start, obj.end];
          } else if (type === "match") {
            if (isNaN(obj.value)) {
              this[classname] = obj.value;
            } else {
              this[classname] = Number(obj.value);
            }
          }
        }
      });
      this.size = this.paginationData.size;
    },
    setFilterFunc(key, value) {
      this.setFilter(key, value);
    },
    checkFilterData() {
      return this.filterDate != null && this.filterDate.length > 0;
    },
    changePage(key, value) {
      this.setPage(key, value);
      this.setPage("page", 1);
    },

  },
  watch: {},
};
</script>

<style scoped></style>
